import React, { useState, useEffect, useRef } from 'react';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import styles from './DropdownModal.module.scss';
import { ContainedButton } from '../../../commons/hoc';
import Link from 'next/link';
import Router from 'next/router';
const DropdownModal = ({ data, onToggle, isDark }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const handleToggle = () => {
    setIsOpen(!isOpen);
  };
  useEffect(() => {
    if (isOpen) {
      onToggle(true);
    } else {
      onToggle(false);
    }
  }, [isOpen]);
  useEffect(() => {
    if (isOpen) {
      const handleClickOutside = (event) => {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target)
        ) {
          setIsOpen(false);
          onToggle(false);
        }
      };
      document.addEventListener('mousedown', handleClickOutside);

      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [isOpen]);

  return (
    <div className={styles.dropdownContainer} ref={dropdownRef}>
      {/* Trigger Button */}
      <button
        className={`${styles.triggerButton} ${isDark || isOpen ? styles.open : ''}`}
        onClick={handleToggle}
      >
        Shop Products
        <span className={styles.icon}>
          {isOpen ? (
            <ExpandLessIcon className="icon" />
          ) : (
            <ExpandMoreIcon className="icon" />
          )}
        </span>
      </button>

      {/* Dropdown Modal */}
      {isOpen && (
        <div className={styles.dropdownModal}>
          <div className={styles.modalContent}>
            {/* Dynamic Sections */}
            {data.map((section, index) => (
              <div key={index} className={styles.section}>
                <Typography variant="h4" className={styles.sectionHeading}>
                  {section.heading}
                </Typography>
                <ul className={styles.itemList}>
                  {section.items.map((item, idx) => (
                    <li
                      key={idx}
                      className={styles.item}
                      onClick={() => setIsOpen(false)}
                    >
                      <Link href={item.url} passHref>
                        <a className={styles.link}>
                          <Typography variant="h5">{item.label}</Typography>
                          {item.icon && (
                            <span className={styles.itemIcon}>{item.icon}</span>
                          )}
                          {item.icon1 && (
                            <span className={styles.itemIcon1}>
                              {item.icon1}
                            </span>
                          )}
                          {item.icon2 && (
                            <span className={styles.itemIcon1}>
                              {item.icon2}
                            </span>
                          )}
                        </a>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Footer Button */}
          <div className={styles.footerButtonContainer}>
            <ContainedButton
              className={styles.footerButton}
              onClick={() => {
                Router.push('/products'), setIsOpen(false);
              }}
              arrow={true}
              textContainerWidth="9rem"
            >
              Shop All Products
            </ContainedButton>
          </div>
        </div>
      )}
    </div>
  );
};

export default DropdownModal;
